import React, { Component } from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";

const EDIT_CARD_ENDPOINT = "https://qibipay.azurewebsites.net/api/CardEdit";

class EditCardModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - onClose
             - card
             - onCardEdit
             - logout
        */
        super(props);

        this.state = {
            errors: {

            },

            loading: false,
            success: false
        }
    }

    async submit() {
            this.setState({loading: true, errors:{}, errorMessage:null});

            const options = {
                method: 'POST',
                uri: EDIT_CARD_ENDPOINT,
                body: {
                    access_code: this.props.access_code,
                    card_id: this.props.card.cardId,
                    name: this.nameRef.value,
                    personId: this.personIdRef.value
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                this.setState({errorMessage: response.body.msg});
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            this.setState({
                success: true
            });

            //Success
            this.props.onCardEdit(response.body.card);
    }

    reset() {
        this.setState({
            errors: {

            },

            loading: false,
            success: false
        });
        this.props.onClose();
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                }
            }} >
                <h2>Edit Card Details</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}

                {this.state.loading ? (
                    <div>
                        <p>Editing card...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Card edited successfully!</p>
                    </div>
                ) : (
                    <Form horizontal style={{
                        marginLeft: "32px",
                        marginRight: "32px"
                    }}>
                        <ValidatedFormComponent name="Person ID"
                                                type="text"
                                                placeholder="Enter person ID"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.personIdRef=ref}
                        />
                        <ValidatedFormComponent name="Name"
                                                type="text"
                                                placeholder="Enter name"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.nameRef=ref}
                        />
                        <Col sm={4}/>
                        <Col sm={8}>
                            <Button bsStyle="primary" onClick={this.submit.bind(this)}>
                                Edit Card
                            </Button>
                        </Col>
                    </Form>
                )}
            </Modal>
        );
    }

}

export default EditCardModal;